import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于韩国电影的常见疑问，这里都有答案
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-300/30 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}